import { EventBusKey } from '@vueuse/core';
import { EntrySubject } from './models/entry/entry';

export const subjectRefreshedKey: EventBusKey<EntrySubject> = Symbol('subjectRefreshed');

export const createJobErrorKey: EventBusKey<Error> = Symbol('Job:Write:Error');

export const verificationRequiredKey: EventBusKey<void> = Symbol('Studio:Verification:Required');
